module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"base":{"ais":{"clear_refinements":{"label":"Alle Filter zurücksetzen"}}}}}}}')
  delete Component.options._Ctor
}
